import type { StrictlyBasisPoints } from "@vyne-shared/utils/currency";

export interface StripeRedirectProps {
    /** The ID of the Payment Intent that Stripe is processing. */
    payment_intent: string;

    /** The client secret used by Stripe to act on the Payment Intent. */
    payment_intent_client_secret: string;

    /** Total balance that we were making a payment towards. */
    balance?: StrictlyBasisPoints;
}

/** Validate search parameters to determine if they include Stripe redirect */
export function validateStripeParams(search?: Record<string, unknown>) {
    if (
        search &&
        typeof search.payment_intent === "string" &&
        search.payment_intent &&
        typeof search.payment_intent_client_secret === "string" &&
        search.payment_intent_client_secret
    ) {
        const stripeParams: StripeRedirectProps = {
            payment_intent: search.payment_intent,
            payment_intent_client_secret: search.payment_intent_client_secret,
            balance:
                typeof search.balance === "number"
                    ? (search.balance as StrictlyBasisPoints)
                    : typeof search.balance === "string"
                      ? (parseInt(search.balance) as StrictlyBasisPoints)
                      : undefined,
        };

        return stripeParams;
    }

    return undefined;
}
